import React from "react";
import InfiniteTable from "./InfiniteTable";
import { Link } from "react-router-dom";
import { Container, Button, Typography } from "@mui/material";

const columns = [
  { id: "name", editable:"/equation", editablePk:"pk", label: "Name" },
];

export const Equations = () => {
  return (
    <>
      <Container style={{ textAlign: "right" }}>
        <Link
          to="/equation/add"
          style={{ textDecoration: "none" }}
          color="secondary"
        >
          <Button variant="contained" color="primary">
            <Typography variant="subtitle2" className="text-white">
              Add Equation
            </Typography>
          </Button>
        </Link>
      </Container>
      <Container>
        <InfiniteTable
          apiep="data/api/equations/"
          columns={columns}
          data={null}
          dataMapByColumn="id"
          deletable={false}
          editable={true}
          filterable={true}
          label="Equations"
          fetchingModal={null}
        />
      </Container>
    </>
  );
};
